//Componentes Generales
import React, { useState, useContext, useEffect} from 'react';
import moment from "moment-timezone";

import { useNavigate } from 'react-router-dom';

//Tipos de Prioridades
import { PRIORITY, PRIORITYIN } from '../../utils/priority';
import Select from 'react-select';

//Estructuras
import { createEstructuraConsumo, createEstructuraProducto, estructuraImputaciónRRHH, estructuraOrdenTrabajo } from '../../utils/estructuras';

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faXmark,
    faEye,
    faEyeSlash
} from "@fortawesome/free-solid-svg-icons";

// Estilos
import './FormConsumo.css'
import {COLOR_BOTONES} from '../../constants/colors';

//Components
import BtnArchivos from '../BtnArchivos/BtnArchivos';
import ModuloItem from '../ModuloItem/ModuloItem';
//Contexto
import activoContext from '../../context/activoContex/activoContex';
import agregarReqContext from '../../context/agregarReq/agregarReqContext';

import { estructuraTarea, estructura_producto } from '../../utils/estructuras';
import authContext from '../../context/authentication/authContex';
import ProductosSubtabla from '../productosSubtabla/ProductosSubtabla';
import TareasSubtabla from '../tareasSubtabla/TareasSubtabla';
import ImputacionRRHHSubtabla from '../imputacionRRHHSubtabla/ImputacionRRHHSubtabla';
import { parse } from '@fortawesome/fontawesome-svg-core';
import Swal from 'sweetalert2';
import ControlesSubtabla from '../controlestSubtabla/ControlesSubtabla';

// Constante con estructura del producto.



/*
    Componente encargado de mostrar el formulario de requerimiento.
        Donde edicion determina si mostrar algunas cosas y a que logica seguir en el guardado.
              req es la estructura del requerimiento.
              files son los archivos que almacena/ra el requerimiento.
              itemList son los items/productos del requerimeinto.
              productList son los productos disponibles.
              guardarReq es la función del context que guarda el requerimiento.
              cerrar es la función encargada de ocultar el dialogo.
*/
function FormConsumo({ req, activoAddingConsumo = undefined, cerrar, mode, type = ""}) {
    const navigate = useNavigate();

    const generateActivoSelect = activoAddingConsumo ? {id: activoAddingConsumo._id, value: activoAddingConsumo.codActivo, label: activoAddingConsumo.name} : {id:'', value:'', label:''};

    //State del requerimiento.
    const [requeriment, setRequeriment] = useState({...createEstructuraConsumo(), activoID: activoAddingConsumo ? activoAddingConsumo._id : undefined, codActivo: activoAddingConsumo ? activoAddingConsumo.codActivo : undefined, activo: generateActivoSelect, title: activoAddingConsumo ? `Generando consumo sobre ${activoAddingConsumo.name}` : ''});

    const [tablaSeleccionada,setTablaSeleccionada] = useState('componentes');
    const [mostrarControles, setMostrarControles] = useState(true);

    //Context Edit Requerimiento
    const addContext = useContext(agregarReqContext);
    const { guardarConsumo } = addContext;
    const ahContext = useContext(authContext);
    const {usuario} = ahContext

    // opciones para que se puedan ver todos los nombre de los activos
    const {activoList, actualizarProcProgramado} = useContext(activoContext)
    const optionsActivos = activoList?.map((dato) =>({ value: dato.name, label: dato.name, activoID:dato._id, activoCod: dato.codActivo  })); 
 
    //State que determina la muestra de las opciones de selección de estado.
    const [displayOptions, setDisplayOptions] = useState();
    
    //State necesario para que el usuario no envie muchas veces el requerimiento cuando aprieta el boton muchas veces
    const [controlBotonEnviar, setControlBotonEnviar] = useState(false);

    const [archivoTotal,setArchivoTotal] = useState([]);
    
    const completedTasks = requeriment.tareas?.filter(t => t.done === true).length;

    /*
        Manejador de requerimiento ante cambio de titulo.
            Donde data es el titulo ingresada por el usuario. 
        El parametro data es el valor con el que se setea el titulo del requerimiento.
    */
    const handleChangeTitle = (data) => {
        setRequeriment({ ...requeriment, title: data });
    }

    /*
        Manejador de requerimiento ante cambio de fecha Entrega.
            Donde data es la fecha Entrega ingresada por el usuario. 
        El parametro data es el valor con el que se setea la fecha Entrega del requerimiento.
    */
    const handleChangeFecMov = (data) => {
        let dataMoment = moment(data).tz("America/Argentina/Buenos_Aires");
        setRequeriment({ ...requeriment, fecMov: dataMoment });
    }

    const handleChangeFecInicioFin = (data) => {
        setRequeriment(prevReq => {
            let reqModelado = {...prevReq, [data.target.name]: moment(data.target.value).tz("America/Argentina/Buenos_Aires")};
            console.log("reqModelado.fecInicio");
            console.log(reqModelado.fecInicio);
            console.log("reqModelado.fecFin");
            console.log(reqModelado.fecFin);
            
            if(reqModelado.fecInicio && reqModelado.fecFin){
                let start = moment(reqModelado.fecInicio);
                let end = moment(reqModelado.fecFin);
                let cantDias = end.diff(start, "days"); 
                for(const p of reqModelado.productos){
                    if(cantDias > 0){
                        if(p.tipPro != '' && p.quantity > 0){
                            p.promedioDia = (p.quantity / cantDias).toFixed(2);
                        }
                    }else p.promedioDia = 0;
                }
                reqModelado.cantDias = cantDias;
            }
            return {...reqModelado};
        })
        
    }

    /*
        Manejador de requerimiento ante cambio de observación.
            Donde data es la observación ingresada por el usuario. 
        El parametro data es el valor con el que se setea la observación del requerimiento.
    */
    const handleChangObservation = (data) => {
        setRequeriment({ ...requeriment, observ: data });
    }

    /* 
        Determina si se muestra o no el display de opciones de prioridades.
    */
    const displayOpciones = () => {
        displayOptions ? setDisplayOptions(false) : setDisplayOptions(true);
    }

    /*
        Guarda el requerimiento mediante función del context.
        Distintos comportamientos segun variable edición.
    */
    const handleSaveRequirement = async () => {
        //setControlBotonEnviar(true); // Bloqueo el botón mientras se esta enviando el requerimiento.
        let consumoModelado = {...requeriment};
        const newLista = requeriment.productos.filter((d) => d.artCod !== '');
        consumoModelado.productos = newLista;
        
        let resp = await guardarConsumo(consumoModelado, usuario);
        if(resp){
            Swal.fire({
                icon:'success',
                title:`Consumo registrado con Éxito`,
                text:`El consumo asociado al activo ${requeriment.activo.label} fue registrado correctamente.`                
            })
            setRequeriment({ ...createEstructuraConsumo() });
            cerrar();
        }
    }

    // selecciona el activo 
    const handleChengeActivo = (taSelccionado) => {
        setRequeriment({ ...requeriment, activo:{id:taSelccionado.activoID, value: taSelccionado.activoCod, label:taSelccionado.label}});
    }

    const handleChangeProductos = (prod={}, i, property = '', value = '') => {
        //Se le asigna un id random al item vacio. Esto es para facilitar la eliminación del item en caso de ser necesario.
        setRequeriment((prevReq) => {
            const actualList = (prevReq.productos != undefined) ? prevReq.productos.slice() : [{...createEstructuraProducto()}];
            if(property != '' && value != '' && Object.keys(prod).length == 0){  
                actualList[i][property] = value;
            }else if(property != ''){
                actualList[i][property] = value;
            }
            else{
                const prodTemp = {...prod, user_id: (Math.random() * 100).toString()};
                if(requeriment.cantDias > 0){
                    let promedioDia = prod.quantity / requeriment.cantDias;
                    prodTemp.promedioDia = promedioDia.toFixed(2);
                }
                if(prod.tipPro != ''){
                    if(actualList[i].tipPro !== ''){
                        actualList[i] = prodTemp;
                    }else{
                        const nuevaEstructura = {...createEstructuraProducto()};
                        actualList[i] = prodTemp;
                        actualList.push(nuevaEstructura);
                    }
                }
            }
            let newReq = {...requeriment,['productos']:actualList}
            return newReq;
        })
    }

    const handleDeleteProd = (prod, index) => {
        let actualProductos = requeriment.productos.slice();
        if(prod.tipPro != ''){
            let productosToUpdate = actualProductos.filter((p,i) => i != index);
            setRequeriment({...requeriment,['productos']:productosToUpdate});
        }
    }

    useEffect(()=>{
        if(req != undefined && Object.keys(req).length > 0 ){
            let reqModelado = {...req};
            let productosModelados = (req.productos != undefined && req.productos.length > 0) ? req.productos.slice() : [{...estructura_producto}];
            if(productosModelados[0].artCod != '') productosModelados.push({...estructura_producto});
            reqModelado.productos =  productosModelados;
            let docDeepCopy = JSON.parse(JSON.stringify(reqModelado));
            setRequeriment(docDeepCopy);
        }
    },[req])

    return (
        // <div className={`container-gr-addreq`} id={(mode == 'editOTFromActivos' || mode == 'normal') ? 'fullScreen' : ''}>
        <div className={`formConsumoContainer`} id={(mode == 'editOTFromActivos' || mode == 'normal') ? 'fullScreen' : ''}>
            <div className='container-r-list-item-header'>
                <input placeholder='Ingrese un título...' className='list-item-header-title-addReq' value={requeriment.title} onChange={(data) => handleChangeTitle(data.target.value)} autoFocus={true} style={{ fontWeight: "bold" }} ></input>
                <button
                    className='ocultarControlesBtn'
                    onClick={() => setMostrarControles(!mostrarControles)}
                    title={mostrarControles ? 'Ocultar controles' : 'Mostrar controles'}
                >
                    <FontAwesomeIcon icon={mostrarControles ? faEye : faEyeSlash} />
                    {mostrarControles ? 'Ocultar controles' : 'Mostrar controles'}
                </button>
                <button className='minimizarBtn' onClick={() => cerrar()}>X</button>
            </div>

            {mostrarControles && <>
                <div className="container-AddReq-item-activoAndDeliveryDate">
                    {(requeriment.tDocCodFor != undefined && requeriment.tDocNroFor != undefined) && <div className='comprobanteDiv'>
                        <span>Comprobante: <label>{`${requeriment.tDocCodFor} - ${requeriment.tDocNroFor}`}</label></span>
                    </div>}

                    <div className='container-AddReq-item-activo'> <span>Activo:</span>
                        <Select
                            styles={{
                            input: (base) => ({
                                ...base,
                                width: "100%",
                                padding: ".4rem",
                                borderRadius: ".5rem",
                                fontSize: "1rem",
                                transition: "border-color .5s"
                            })
                        }}
                        placeholder="Elija el activo que corresponda..."
                        options={optionsActivos}
                        isDisabled={(req != undefined) || (mode && mode == 'editOTFromActivos') ? true : false}
                        value={requeriment.activo}
                        onChange={(selectedOption) => handleChengeActivo(selectedOption)}/>
                    </div>

                    <div className="container-r-item-title-details">
                        <label>Fecha de Movimiento</label>
                        <input
                            type="date"
                            className="label-AddReq-fecha"
                            value={moment(requeriment.fecMov).format("YYYY-MM-DD")}
                            onChange={(data) => handleChangeFecMov(data.target.value)}
                        />
                    </div>
                </div>

                <div className='containerFechasCalculadas'>
                    <div className="container-r-item-title-details">
                        <label>Fecha de Inicio</label>
                        <input
                            type="date"
                            name='fecInicio'
                            className="label-AddReq-fecha"
                            value={moment(requeriment.fecInicio).format("YYYY-MM-DD")}
                            onChange={(data) => handleChangeFecInicioFin(data)}
                        />
                    </div>
                    <div className="container-r-item-title-details">
                        <label>Fecha de Fin</label>
                        <input
                            type="date"
                            name='fecFin'
                            className="label-AddReq-fecha"
                            value={moment(requeriment.fecFin).format("YYYY-MM-DD")}
                            onChange={(data) => handleChangeFecInicioFin(data)}
                        />
                    </div>
                    <div className="container-r-item-title-details">
                        <label>Cantidad de días</label>
                        <h5 className='labelCantSingladuras'>{requeriment.cantDias ?? 0}</h5>
                    </div>
                </div>

                <div className='container-AddReq-item-gral'>
                    <div className='container-AddReq-item-details-text'>
                        <div className='container-r-item-title-details'>Texto Adicional</div>
                        <div className='container-input-texto'>
                            <div className='r-list-item-details-data-v'><textarea placeholder='Ingrese texto adicional' className='r-item-text-input' style={{ fontWeight: 600 }} value={requeriment.observ} onChange={(data) => handleChangObservation(data.target.value)}></textarea></div>
                        </div>
                    </div>
                </div>
            </>}

            <div className="tablasHijasDiv">
                <div className="opcionesHijasDiv">
                    <button className={(tablaSeleccionada === 'componentes') ? `opcionHijaBtn selected` : 'opcionHijaBtn'} onClick={() => setTablaSeleccionada('componentes')}>Materiales</button>
                </div>
                <ProductosSubtabla productos={requeriment.productos ?? []} handleChangeProductos={handleChangeProductos} componentePadre='FormConsumo' handleDeleteProd={handleDeleteProd} tablaSeleccionada={tablaSeleccionada}/>
            </div>

            <div className='container-button-rq-save-new'  >
                <button className='button-rq-save-new' style={{backgroundColor: COLOR_BOTONES}} disabled={controlBotonEnviar} onClick={handleSaveRequirement}>
                    Guardar
                </button>
            </div>

        </div>
    );
}

export default FormConsumo